import { REDUCER_NAME as APP_REDUCER_NAME } from 'constants';
import { REDUCER_NAME } from './constants';

export const getState = state => state[APP_REDUCER_NAME][REDUCER_NAME];
